import { Check, Eye, EyeOff, LockKeyhole, ShieldCheck } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthContext";
import { BrandLogo } from "../components/Icons";

export function LoginPage() {
  const { needsBootstrap, login, bootstrap } = useAuth();
  const [username, setUsername] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault(); setError("");
    if (needsBootstrap && password !== confirmPassword) { setError("两次输入的密码不一致"); return; }
    setBusy(true);
    try {
      if (needsBootstrap) await bootstrap(username, displayName, password);
      else await login(username, password);
    } catch (cause) { setError(cause instanceof Error ? cause.message : "登录失败"); }
    finally { setBusy(false); }
  }

  return <main className="auth-page">
    <section className="auth-story">
      <div className="auth-brand"><BrandLogo /></div>
      <div className="auth-story-copy"><span className="eyebrow light">PRIVATE WORKSPACE</span><h1>链接全球，<br />贸易有数。</h1><p>进出口项目、经营成本与市场情报集中管理，写入权限与查看权限清晰分开。</p></div>
      <div className="auth-trust"><span><Check size={15} /> 服务端权限校验</span><span><Check size={15} /> 密码加盐哈希</span><span><Check size={15} /> 7 天安全会话</span></div>
    </section>
    <section className="auth-form-side"><form className="auth-card" onSubmit={submit}>
      <div className="auth-card-icon"><ShieldCheck size={22} /></div>
      <span className="eyebrow">{needsBootstrap ? "FIRST SETUP" : "WELCOME BACK"}</span>
      <h2>{needsBootstrap ? "初始化管理员" : "登录米纳海"}</h2>
      <p>{needsBootstrap ? "这是系统首次运行。创建的账户将拥有全部管理权限。" : "输入账户信息进入进出口贸易工作区。"}</p>
      {error && <div className="auth-error">{error}</div>}
      {needsBootstrap && <label className="form-field"><span>姓名</span><input autoComplete="name" required maxLength={40} value={displayName} onChange={(event) => setDisplayName(event.target.value)} placeholder="例如：吴先生" /></label>}
      <label className="form-field"><span>用户名</span><input autoComplete="username" required minLength={3} maxLength={32} value={username} onChange={(event) => setUsername(event.target.value.toLowerCase())} placeholder="例如：admin" /></label>
      <label className="form-field"><span>密码</span><div className="password-input"><LockKeyhole size={16} /><input type={showPassword ? "text" : "password"} autoComplete={needsBootstrap ? "new-password" : "current-password"} required minLength={needsBootstrap ? 10 : 1} maxLength={128} value={password} onChange={(event) => setPassword(event.target.value)} placeholder={needsBootstrap ? "至少 10 个字符" : "输入密码"} /><button type="button" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? "隐藏密码" : "显示密码"}>{showPassword ? <EyeOff size={16} /> : <Eye size={16} />}</button></div></label>
      {needsBootstrap && <label className="form-field"><span>确认密码</span><input type="password" autoComplete="new-password" required minLength={10} maxLength={128} value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} placeholder="再次输入密码" /></label>}
      <button className="button primary auth-submit" disabled={busy}>{busy ? "正在验证…" : needsBootstrap ? "创建管理员并进入" : "安全登录"}</button>
      <small className="auth-note">连续 5 次密码错误后，账户将锁定 15 分钟。</small>
    </form></section>
  </main>;
}
